// components/Paragraph.jsx
import React from "react";
import DOMPurify from "dompurify";

const Paragraph = ({ content }) => {
  return (
    <div
      style={{ marginBottom: "16px" }}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content || "") }}
    />
  );
};

export default Paragraph;
